<template>
    <div class="easy-carousel" 
    :class="{
        'is-contain':contain
    }"
     :key="current" :style="{
        'background-image':`url(${images[current].src})`
    }">
        <button @click="prev" class="prev arrow">
            <i class="material-icons">keyboard_arrow_left</i>
        </button>
        <button @click="next" class="next arrow">
            <i class="material-icons">keyboard_arrow_right</i> 
        </button>

        <div class="caption" v-if="images[current].caption">
            {{images[current].caption||""}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'easy-carousel',
    props: {
        images: {
            type: Array,
            required: true
        },
        contain: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            current: 0
        }
    },
    mounted() {
        console.log("here");
        console.log(this);
    },
    methods: {
        next(ev) {
            ev.preventDefault();
            this.current = (this.current+1)%this.images.length;
        },
        prev(ev) {
            ev.preventDefault();
            if(this.current == 0) {
                this.current = this.images.length-1;
            }
            else {
                this.current -= 1;
            }
        }
    },
    computed: { 
    }
}
</script>

<style scoped>
.easy-carousel {
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position:center center;
    position: relative;
}



.arrow {
    border:0;
    position: absolute;
    width: 85px;
    height: 85px;
    background-color: var(--primary-color); 
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--secondary-color);
    font-weight: bold;
    
    cursor: pointer;
    transition-duration: .2s;
    bottom: 0;
}

.arrow .material-icons {
    font-size: 2.2em;
}

.next {
    right: 0;
}
.prev {
    left: 0;
}

.arrow:hover {
    background-color: var(--secondary-color);
    color: var(--primary-color);
    transition: 0.4s;
}

.caption {
    position: absolute;
    width:calc(100% - 190px);
    background-color: rgba(0, 0, 0, 0.5);
    color: var(--primary-color);
    bottom: 0px;
    left: 85px;
    padding: 10px;
    text-align: center;
    max-height:85px;
    overflow-y: auto;
}

.is-contain {
    background-size: contain !important;
    background-repeat: no-repeat;
}
</style>